/** Contrat pur partage par les ecrans, l'atelier et leurs controles. */
export const ELEMENTS_CADRE_CANVAS = Object.freeze(['rail', 'identite', 'portes', 'recherche', 'statistiques', 'actions', 'filtres', 'tri', 'menu', 'vues', 'tiroir', 'fond']);
export const ELEMENTS_CADRE_LIBELLES = Object.freeze({ rail: 'Rail', identite: "Identité de l’app", portes: 'Portes', recherche: 'Recherche', statistiques: 'Statistiques', actions: 'Actions', filtres: 'Filtres', tri: 'Tri', menu: 'Menu …', vues: 'Sélecteur de vues', tiroir: 'Tiroir', fond: 'Fond du contenu' });
export const ELEMENTS_CADRE_REPERES = Object.freeze({ rail: '1', identite: '1a', portes: '1b', recherche: '2b', statistiques: '2c', actions: '3a', filtres: '3b', tri: '3b', menu: '3b', vues: '3c', tiroir: '4', fond: '5' });
/**
 * LA PARTIE 1 D'UNE PORTE CANVAS (rail, identite, portes) est IMPLICITE : sans
 * elle, l'utilisateur ne rejoint plus les autres portes de l'app. Elle se
 * NORMALISE a la lecture (une declaration ancienne ou `elements: []` la
 * retrouve), elle ne se refuse pas. L'App Canvas reste libre, partie 1 comprise.
 */
export const PARTIE_1_PORTE = Object.freeze(['rail', 'identite', 'portes']);
export const MENTION_PARTIE_1_PORTE = 'Ne peut être retiré en porte Canvas';
/** Les elements qu'une surface sait alimenter (tout sauf identite, portes, fond). */
export const ELEMENTS_CADRE_ALIMENTABLES = Object.freeze(['rail', 'recherche', 'statistiques', 'actions', 'filtres', 'tri', 'menu', 'vues', 'tiroir']);
export function obligationsElementsCadre(level) { return level === 'space' ? Object.fromEntries(PARTIE_1_PORTE.map((id) => [id, MENTION_PARTIE_1_PORTE])) : {}; }
export function resoudreElementsCadre(canvas) {
  if (canvas == null) return [...ELEMENTS_CADRE_CANVAS];
  const lus = lireElementsCadre(canvas);
  return canvas.level === 'space' ? ELEMENTS_CADRE_CANVAS.filter((id) => lus.includes(id) || PARTIE_1_PORTE.includes(id)) : lus;
}
function lireElementsCadre(canvas) {
  if (canvas.elements !== undefined && canvas.keeps !== undefined) throw new Error('Canvas : elements et keeps ne peuvent pas coexister.');
  if (canvas.elements !== undefined) {
    if (!Array.isArray(canvas.elements)) throw new Error('Canvas : elements attend une liste.');
    const inconnus = canvas.elements.filter((id) => !ELEMENTS_CADRE_CANVAS.includes(id));
    if (inconnus.length) throw new Error(`Canvas : element inconnu ${inconnus.join(', ')}.`);
    if (new Set(canvas.elements).size !== canvas.elements.length) throw new Error('Canvas : element declare deux fois.');
    return ELEMENTS_CADRE_CANVAS.filter((id) => canvas.elements.includes(id));
  }
  const resultat = canvas.level === 'space' ? ['rail', 'identite', 'portes', 'recherche', 'statistiques', 'fond'] : ['fond'];
  const zones = { '1b': ['rail', 'identite'], '2b': ['recherche'], '2c': ['statistiques'], '3a': ['actions'], '3b': ['filtres', 'tri', 'menu'] };
  for (const zone of canvas.keeps ?? []) {
    if (zones[zone] === undefined || (canvas.level === 'space' && !['3a', '3b'].includes(zone))) throw new Error(`Canvas : zone historique inconnue ${zone}.`);
    resultat.push(...zones[zone]);
  }
  if ((canvas.keeps ?? []).some((zone) => zone === '3a' || zone === '3b')) resultat.push('vues');
  return ELEMENTS_CADRE_CANVAS.filter((id) => resultat.includes(id));
}
/** Conversion de declaration, sans modifier le fichier historique ni son rendu. */
export function declarationCadreCanonique(canvas, level) {
  const { keeps, ...accord } = canvas;
  const elements = resoudreElementsCadre({ ...canvas, level });
  const sortie = { ...accord, elements };
  if (level === 'app' && canvas.elements === undefined && canvas.alimente === undefined) {
    sortie.alimente = elements.filter((id) => ELEMENTS_CADRE_ALIMENTABLES.includes(id));
    if (sortie.alimente.length === 0) delete sortie.alimente;
  }
  return sortie;
}
/**
 * Pourquoi un element ne peut pas etre garde. Sur une surface Canvas (App
 * Canvas, porte Canvas avec ou sans jeu), garder un element VAUT declaration
 * qu'il est alimente, par le moteur s'il y en a un, sinon par la surface
 * (poserMenu, poserFiltres...) : rien ne se grise pour cause d'alimentation.
 * Seules restent les dependances (identite et portes ont besoin du rail) et
 * l'absence de portes. `capacites.moteur` ne decide plus rien.
 */
export function raisonsElementsCadre(canvas, capacites = {}) {
  const elements = resoudreElementsCadre(canvas);
  const raisons = {};
  for (const id of ['identite', 'portes']) if (!elements.includes('rail')) raisons[id] = 'Cet élément a besoin du rail.';
  if (capacites.portes !== true) raisons.portes = "Cette app n’a pas de portes.";
  return raisons;
}
/**
 * Les fournisseurs (`alimente`) d'un cadre SANS moteur (App Canvas, porte
 * Canvas sans jeu) : ce qui etait deja declare, plus tout element garde
 * alimentable. Une seule logique pour les deux niveaux, a une nuance pres :
 * sur une porte, le rail porte la liste des portes de l'app, tenue par le
 * gabarit, donc la surface ne l'alimente pas.
 */
export function alimenteSansMoteur(elements, deja = [], level = 'app') {
  const alimentables = ELEMENTS_CADRE_ALIMENTABLES.filter((id) => level !== 'space' || id !== 'rail');
  return [...new Set([...(Array.isArray(deja) ? deja : []), ...elements.filter((id) => alimentables.includes(id))])];
}
export function verifierCadreCanvas(canvas, capacites) {
  const elements = resoudreElementsCadre(canvas);
  const raisons = raisonsElementsCadre(canvas, capacites);
  const impossible = elements.find((id) => raisons[id] !== undefined);
  if (impossible) throw new Error(`Canvas : ${ELEMENTS_CADRE_LIBELLES[impossible]} : ${raisons[impossible]}`);
  return elements;
}
